import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  inject,
} from '@angular/core';

import { PublicCartService } from '../../services/public-cart.service';
import { PublicCartQuantityComponent } from '../../components/public-cart-quantity/public-cart-quantity.component';
import { HttpErrorService } from '@web/common';
import { PublicQuantityChangeFailureEvent } from '../../events/public-quantity-change-failure-event';
import { HttpErrorResponse } from '@angular/common/http';
import { PublicCartUpdateItem } from '../../models/public-cart-update-item';

@Component({
  selector: 'app-public-cart-quantity-update',
  imports: [PublicCartQuantityComponent],
  templateUrl: './public-cart-quantity-update.component.html',
  styleUrl: './public-cart-quantity-update.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCartQuantityUpdateComponent {
  private readonly shoppingCart = inject(PublicCartService);
  private readonly error = inject(HttpErrorService);

  public readonly id = input.required<string>();
  public readonly quantity = input.required<number>();
  public readonly disabled = input<boolean>(false);

  /* prettier-ignore */
  public readonly failureEvent = output<PublicQuantityChangeFailureEvent>();
  public readonly successEvent = output<void>();

  public handleQuantityChange(quantity: number): void {
    const id = this.id();

    this.shoppingCart
      .updateQuantity(new PublicCartUpdateItem({ quantity, id }))
      .subscribe({
        next: () => this.successEvent.emit(),
        error: (response) => this.notifyFailureEvent(response),
      });
  }

  private notifyFailureEvent(response: HttpErrorResponse): void {
    this.failureEvent.emit(
      new PublicQuantityChangeFailureEvent({
        reasons: this.error.extract(response).messages(),
      }),
    );
  }
}
